import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { capitalizeFirstLetter } from '../utils/capitalize';

interface CustomTextInputProps {
    children?: React.ReactNode;
    disabled?: boolean;
    error?: boolean;
    errorText?: string;
    helperText?: string;
    onChange?: (text: string) => void;
    onBlur?: (text: string) => void;
    value?: unknown;
    label?: string;
    type?: React.HTMLInputTypeAttribute;
    name?: string;
    id?: string;
    multiline?: boolean;
    required?: boolean;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    placeholder?: string;
    maxLength?: number;
    autoFocus?: boolean;
    readOnly?: boolean;
    autoComplete?: string;
    min?: number;
    max?: number;
    step?: number;
}

const CustomTextInput: React.FC<CustomTextInputProps> = ({
    children,
    disabled = false,
    error = false,
    errorText,
    helperText,
    onChange = () => {},
    onBlur = () => {},
    value,
    label = '',
    type = 'text',
    name,
    id,
    multiline = false,
    required = false,
    startAdornment,
    endAdornment,
    placeholder,
    maxLength,
    autoFocus = false,
    readOnly = false,
    autoComplete = 'off',
    min,
    max,
    step,
}) => {
    return (
        <div className="pad-5px w-100">
            <TextField
                label={capitalizeFirstLetter(label)}
                placeholder={placeholder}
                type={type}
                multiline={multiline}
                variant="outlined"
                onChange={(event) => onChange(event.target.value)}
                onBlur={(event) => onBlur(event.target.value)}
                value={value}
                disabled={disabled}
                error={error}
                helperText={error ? errorText : helperText}
                autoComplete={autoComplete}
                name={name}
                id={id}
                fullWidth
                size={multiline ? 'medium' : 'small'}
                slotProps={{
                    inputLabel: { shrink: true },

                    input: {
                        startAdornment: startAdornment && <InputAdornment position="start">{startAdornment}</InputAdornment>,
                        endAdornment: endAdornment && <InputAdornment position="end">{endAdornment}</InputAdornment>,
                        readOnly: readOnly,
                    },
                    htmlInput: {
                        maxLength,
                        min,
                        max,
                        step,
                    },
                }}
                required={required}
                autoFocus={autoFocus}
            />
        </div>
    );
};

export default CustomTextInput;
